import styled from "styled-components"

export const ButtonContainer = styled.button<{ isHovered: boolean }>`
  position: relative;
  background: ${(props) => (props.isHovered ? "#e0e0e0" : "#f3f3f3")};
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  /* scopeá si podés (ej. .rte) para no tocar otros botones */
&.active {
  background: #eef2ff;
  border-color: ${(props) => props.theme.colors.Primary};
  color: ${(props) => props.theme.colors.Primary};             /* Lucide usa stroke="currentColor" → pinta el ícono */
  box-shadow: 0 0 0 2px rgba(37,99,235,.12) inset;
}

&.active:hover {
  background: ${(props) => props.theme.colors.Primary40};
}
`

export const ToolbarContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: scroll;
  flex-wrap: nowrap;
  gap: 8px;
  padding: 16px 8px;
  background: white;
  border-bottom: 1px solid rgb(242 242 243);
  border-radius: 4px 4px 0px 0px;
  position: sticky;
  top: 0px;
  z-index: 1000;

  @media(min-width: 768px){
    top: -42px;
  }
`


export const NewBadge = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background-color:rgb(101, 103, 235);
  color: white;
  font-size: 9px;
  font-weight: 600;
  padding: 2px 4px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`